import { Component, inject } from '@angular/core';
import { ProxyDynamicService } from '../../shared/service/proxy-dynamic.service';
import { NZ_MODAL_DATA, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-popup-confirm',
  templateUrl: './popup-confirm.component.html',
  styleUrl: './popup-confirm.component.scss'
})
export class PopupConfirmComponent {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  data: any = {};
  constructor(
    private modal: NzModalRef,
    private service: ProxyDynamicService,
    private sharedService: SharedService
  ) {
    this.data = JSON.parse(JSON.stringify(this.nzModalData.dataRow));
  }

  confirm() {
    this.service.lockCard(this.data.card_id, {}).subscribe(() => {
      this.sharedService.showLoading(false);
      this.modal.destroy(true);
    }, (error: any) => {
      this.service.handleError(error)
      this.modal.destroy(false);
    });
  }

  destroyModal() {
    this.modal.destroy();
  }
}
